import React from 'react';
import './RadioInput.scss';

interface RadioInputProps {
  id: string;
  name: string;
  value: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const RadioInput: React.FC<RadioInputProps> = ({
  id,
  name,
  value,
  label,
  checked = false,
  disabled = false,
  onChange,
  className = ''
}) => {
  return (
    <label 
      className={`radio-input ${disabled ? 'radio-input--disabled' : ''} ${className}`}
      htmlFor={id}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="radio-input__input"
      />
      <div className="radio-input__button" />
      <span className="radio-input__label">{label}</span>
    </label>
  );
};

export default RadioInput;